var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderSearchDuotoneWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 12.2915H27.425C28.5451 12.2915 29.1052 12.2915 29.533 12.5095C29.9093 12.7012 30.2153 13.0072 30.407 13.3835C30.625 13.8113 30.625 14.3714 30.625 15.4915V26.5915C30.625 27.7116 30.625 28.2717 30.407 28.6995C30.2153 29.0758 29.9093 29.3818 29.533 29.5735C29.1052 29.7915 28.5451 29.7915 27.425 29.7915H7.575C6.4549 29.7915 5.89484 29.7915 5.46702 29.5735C5.09069 29.3818 4.78473 29.0758 4.59299 28.6995C4.375 28.2717 4.375 27.7116 4.375 26.5915V12.2915Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.9165C4.375 10.0309 4.375 9.08808 4.96079 8.50229C5.54657 7.9165 6.48938 7.9165 8.375 7.9165H12.9265C13.744 7.9165 14.1527 7.9165 14.5203 8.06874C14.8878 8.22099 15.1768 8.51002 15.7549 9.08808L18.9583 12.2915H4.375V11.9165Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7708,
    cy: 20.3123,
    r: 3.14583,
    stroke: "#1B9FBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 23.9585L22.604 26.146",
    stroke: "#1B9FBC",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearchDuotoneWhite);
export default __webpack_public_path__ + "static/media/Folder_search_duotone_white.b23455a74d92677e3340d547c3f49176.svg";
export { ForwardRef as ReactComponent };